export enum EmployerStaffInviteUserFields {
  email = 'email',
  isAdmin = 'isAdmin',
}

export enum EmployerStaffInviteFields {
  users = 'users',
  usersUploadedFile = 'usersUploadedFile',
}

export type EmployerStaffInviteUserValues = {
  [EmployerStaffInviteUserFields.email]: string;
  [EmployerStaffInviteUserFields.isAdmin]: boolean;
};

export type EmployerStaffInviteValues = {
  [EmployerStaffInviteFields.users]?: EmployerStaffInviteUserValues[];
  [EmployerStaffInviteFields.usersUploadedFile]?: any;
};
